import React, { useEffect, useRef, useState } from "react";
import "../Style/saas.css";

import ServicesSection from "../components/saasservices";
import SaassbsServices from "../components/saassbs";
import Saasfuture from "../components/Saasfuture";
import SaasProvide from "../components/Saasindustries";
import SaasBenefits from "../components/Saasbenefits";
import SaasStack from "../components/Saasstack";
import Forms from "../components/Forms";
import DoubtsSection from "../components/Saasdoubts";
import ClientFeedback from "../components/Clientfeedback";
import PageFooter from "../components/Footer";


function SaasPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="saas-page">
        {/* CSS-only pattern layers, no images */}
        <div className="saas-grid-pattern" aria-hidden="true" />
        <div className="saas-blob saas-blob-1" aria-hidden="true" />
        <div className="saas-blob saas-blob-2" aria-hidden="true" />
        <div className="saas-blob saas-blob-3" aria-hidden="true" />

        <div
          className={`saas-overlay ${isVisible ? "saas-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="saas-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="saas-logo saas-anim saas-anim-1"
            /> */}

            <span className="saas-eyebrow saas-anim saas-anim-2">
              SaaS Product Development Services
            </span>

            <h1 className="saas-title saas-anim saas-anim-3">
              Custom SaaS Product Development Services for Scalable Business Growth
            </h1>

            <p className="saas-description saas-anim saas-anim-4">
              At MPeoples, we develop secure, cloud-based SaaS products that help businesses automate operations, improve customer experiences, and scale efficiently. Our SaaS development solutions combine modern architecture, intuitive design, and high-performance technology to build reliable software that grows with your business.
            </p>

            
             <a href="tel:+919876543210"
              className="saas-btn saas-anim saas-anim-5"
            >
              Let&rsquo;s Build Together <span>↗</span>
            </a>

            {/* <button className="saas-btn">
              Let's Build Together <span>↗</span>
            </button> */}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <ServicesSection />
      <SaassbsServices />
      <Saasfuture />
      <SaasProvide />
      <SaasBenefits />
      <SaasStack />
      <Forms />
      <DoubtsSection />
      <ClientFeedback />
      <PageFooter />
    </>
  );
}

export default SaasPage;